<ng-container *ngIf="form">
  <form [formGroup]="form">
    <div mat-dialog-title fxLayout="column">
      <div fxLayoutAlign="space-between center">
        <div class="app-dialog__heading">{{ 'SCANIA_ID_VERIFICATION.TITLE' | translate }}</div>
      </div>
    </div>

    <div class="first-login-content" mat-dialog-content>
      <div class="spinner" *ngIf="loading$ | async; else formTemplate">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
      <ng-template #formTemplate>
        <p style="margin-bottom: 2rem">{{ 'SCANIA_ID_VERIFICATION.CONTENT' | translate }}</p>
        <div class="number-form">
          <mat-form-field>
            <mat-label>{{ 'SCANIA_ID_VERIFICATION.TYPE' | translate }}</mat-label>
            <mat-select [formControl]="form.controls.numberType">
              <mat-option value="AM_ID"> {{ 'SCANIA_ID_VERIFICATION.SPL' | translate }} </mat-option>
              <mat-option value="EGERIA_ID"> {{ 'SCANIA_ID_VERIFICATION.SFP' | translate }} </mat-option>
            </mat-select>
            <mat-error [appControlErrors]="form.controls.numberType"></mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ 'SCANIA_ID_VERIFICATION.NUMBER' | translate }}</mat-label>
            <input [formControl]="form.controls.number" matInput type="text" />
            <mat-error [appControlErrors]="form.controls.number"></mat-error>
          </mat-form-field>
        </div>
        <mat-error *ngIf="errorMessage$ | async as errorMessage">
          {{ errorMessage | translate }}
        </mat-error>
      </ng-template>
    </div>

    <div mat-dialog-actions fxLayoutAlign="flex-end" fxLayoutGap="10px">
      <button class="button button--secondary" (click)="onLogout()" [disabled]="loading$ | async">
        {{ 'APP.LOGOUT' | translate }}
      </button>
      <button class="button button--primary--state-success" (click)="onSubmit()" [disabled]="loading$ | async">
        {{ 'APP.GENERAL.APPLY' | translate }}
      </button>
    </div>
  </form>
</ng-container>
